import { BrowserRouter as Router } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PostHogErrorBoundary } from 'posthog-js/react';
import { AuthProvider } from '@/shared/auth';

import { ShopThemeProvider } from '@/shared/theme';
import { Toaster } from '@/shared/ui/toast';
import { queryClient } from '@/shared/api';
import { AppRoutes } from '@/app/routes/AppRoutes';
import { ErrorFallback } from '@/shared/ui/ErrorFallback';
import { ShopLanguageController } from './i18n/ShopLanguageController';
import { PostHogProvider } from '@/integrations/posthog/PostHogProvider';
import { PostHogConversationsController } from '@/integrations/posthog/PostHogConversationsController';
import { ImpersonationBanner } from '@/app/ImpersonationBanner';
import { RouteHistoryTracker } from '@/shared/lib/router';

export const App = () => {
  return (
    <PostHogProvider>
      <PostHogErrorBoundary fallback={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Router>
              <AuthProvider>
                <RouteHistoryTracker />
                <ShopThemeProvider>
                  <ImpersonationBanner />
                  <ShopLanguageController />
                  <PostHogConversationsController />
                  <AppRoutes />
                  <Toaster />
                </ShopThemeProvider>
              </AuthProvider>
            </Router>
          </LocalizationProvider>
        </QueryClientProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  );
};
